module.exports = __webpack_public_path__ + "img/CH.fda09c52.svg";